import React from "react";
import AuthComponent from "../UI/AuthComponent";
import { Flex, Heading, Text } from "@chakra-ui/react";
import ButtonComponent from "../UI/Button";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";

export default function CheckEmail() {
  const email = localStorage.getItem("reset-email");
  const navigate = useNavigate();
  return (
    <AuthComponent>
      <Heading
        textAlign="center"
        color="#3F434A"
        fontSize="24px"
        fontWeight="medium"
      >
        Check Your Email
      </Heading>
      <Text
        fontSize="14px"
        color="#949493"
        fontWeight="light"
        textAlign="center"
      >
        We sent a password reset link to {email}
      </Text>
      {false && (
        <ButtonComponent
          onClick={() => navigate("/new-password")}
          title="Continue"
          width="100%"
        />
      )}

      <Flex align="center" justify="center" gap="0.5rem">
        <Text color="#2E4A49" fontSize="16px" fontWeight="normal">
          Didn’t receive the email?
        </Text>
        <Link
          style={{ color: "#2BA2DA", fontWeight: "medium" }}
          to="/forgot-password"
        >
          Click here to send
        </Link>
      </Flex>

      <Flex align="center" justify="center" gap="0.5rem">
        <ArrowBackIcon />
        <Link
          style={{
            color: "#2BA2DA",
            fontWeight: "medium",
          }}
          to="/login"
        >
          Back to log in
        </Link>
      </Flex>
    </AuthComponent>
  );
}
